import type { InvestmentSourceTypeEnum, LibraryItemTypeEnum } from 'venn-api';
import { LibraryItemType } from '../types';

// Read from the build-time constant rather than venn-ui-kit's getCurrentTheme: venn-ui-kit depends on
// venn-utils, so importing it here would be circular.
const isRiskProBrand = process.env.USE_GREEN === 'true';

export const BRAND_PROVIDED_ITEM_TYPE: LibraryItemTypeEnum = isRiskProBrand ? 'riskproProvided' : 'vennProvided';

export const BRAND_INVESTMENT_SOURCE: InvestmentSourceTypeEnum = isRiskProBrand ? 'RISKPRO' : 'VENN';

export const toBrandedItemType = (itemType: LibraryItemType): LibraryItemTypeEnum =>
  itemType === LibraryItemType.VENN_PROVIDED ? BRAND_PROVIDED_ITEM_TYPE : itemType;

export const fromBrandedItemType = (value: string): LibraryItemType =>
  value === 'riskproProvided' ? LibraryItemType.VENN_PROVIDED : (value as LibraryItemType);
